import axios from 'axios'

const baseURL = process.env.REACT_APP_API_URL

export function getSMSTemplatesList(parameters){
    return axios.get(baseURL+'smsTemplates?pageSize='+parameters.pageSize+'&pageNumber='+parameters.pageNumber+'&Name='+parameters.name, {
        headers: {
            'Content-Type': 'application/json',
            'authorization' : sessionStorage.getItem("accessToken")
        }
    })
}

export function addNewSMSTemplatesRequest(data){
    const parameters = JSON.stringify(data)
    //console.log(parameters)
      return axios.post(baseURL+'smsTemplates', parameters, {
          headers: {
              'Content-Type': 'application/json',
              'authorization' : sessionStorage.getItem("accessToken")
          }
      })
}

export function updateSMSTemplatesRequest(data){
    const parameters = JSON.stringify(data)
    return axios.patch(baseURL+'smsTemplates/'+data.id, parameters, {
        headers: {
            'Content-Type': 'application/json',
            'authorization' : sessionStorage.getItem("accessToken")
        }
    })
}

export function deleteSMSTemplatesRequest(id){
    return axios.delete(baseURL+'smsTemplates/'+id, {
        headers: {
            'Content-Type': 'application/json',
            'authorization' : sessionStorage.getItem("accessToken")
        }
    })
}

export function getSelectedSMSTemplatesRequest(id){
    return axios.get(baseURL+'smsTemplates/'+id, {
        headers: {
            'Content-Type': 'application/json',
            'authorization' : sessionStorage.getItem("accessToken")
        }
    })
}